import { TitleBlock } from 'src/types/articleCmsTypes';

import s from './Title.module.scss';

export function Title({ title, id }: Omit<TitleBlock, 'type'>) {
  return (
    <h2
      id={id}
      className={s.root}
      dangerouslySetInnerHTML={{ __html: title }}
    />
  );
}
